import { useEffect, useRef, useState } from "react";

import { useAnimatedLoadingMessage } from "./useAnimatedLoadingMessage";

export function useAppLoadingState(getPathname = () => window.location.pathname) {
  const [isLoading, setIsLoading] = useState(false);
  const [hasCompletedAuthFlow, setHasCompletedAuthFlow] = useState(false);
  const getPathnameRef = useRef(getPathname);

  // Keep ref up to date
  useEffect(() => {
    getPathnameRef.current = getPathname;
  });

  useEffect(() => {
    // Check if we've completed auth flow
    if (getPathnameRef.current() === "/authorize") {
      setHasCompletedAuthFlow(true);
    }
  }, []);

  useEffect(() => {
    // Start loading immediately when returning from auth
    if (hasCompletedAuthFlow && getPathnameRef.current() === "/authorize") {
      setIsLoading(true);

      // Stop loading after 3 seconds maximum to prevent infinite loading
      const timeout = setTimeout(() => {
        setIsLoading(false);
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [hasCompletedAuthFlow]);

  const loadingMessage = useAnimatedLoadingMessage(isLoading);

  const stopLoading = () => {
    setIsLoading(false);
  };

  return {
    isLoading,
    loadingMessage,
    stopLoading,
  };
}
